//  Copyright (c) 2017 First Foundry LLC. All rights reserved.
//  @created: 02/08/2017
//  @author: Forest Belton <forest@firstfoundry.co>

import styled from 'styled-components'

export default styled.h3`
  color: #4d4d4d;
  font-size: 26px;
  font-weight: 500;
  margin: 64px 0 35px;
`
